module.exports = __webpack_public_path__ + "img/banner-bg.be4e8b96.png";